<template>
  <div>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="settleAccountsRef"
      class="vxe-table-element"
      size="mini"
      align="center"
      :auto-resize="true"
      :data="tableData"
      :columns="tableColumns"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      height="400"
      @cell-dblclick="dblclickEvent"
      :key="keyTime"
    ></vxe-grid>
    <!-- 分页 -->
    <IPagination
      :total="tableTotal"
      :multipleSelection="multipleSelection"
      @changePageHandler="changePageHandler"
      ref="ipaginationRef"
    />
    <!-- <div class="pagination">
      <el-pagination
        ref="page"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-count="page.pages"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination> -->
    <!-- </div> -->
  </div>
</template>

<script>
  import jumpDetailMixin from '../mixins/jumpDetailMixin.js';
  import billDataMixin from '../mixins/billDataMixin.js';
  export default {
    name: 'OngoingTable',
    props: ['columnList', 'orderName', 'activeTab', 'indexType'],
    mixins: [jumpDetailMixin, billDataMixin],
    data() {
      return {
        tableData: [],
        // tableColumns: [],
        multipleSelection: [],
        tableTotal: 0,
        loading: false,
        keyTime: new Date().getTime(),
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
      };
    },
    computed: {
      tableColumns() {
        return [
          { type: 'seq', title: '序号', width: 50 },
          {
            field: 'orderTypeName',
            title: '单据类型',
            visible: true,
          },
          {
            field: 'orderName',
            title: '名称',
            visible: true,
          },
          {
            field: 'orderNo',
            title: '单据号',
            slots: {
              default: ({ row }) => {
                return [
                  <a href="javascript:void(0)" onClick={() => this.jumpToDetail(row)}>
                    {row.orderNo}
                  </a>,
                  //  row.receivableSettlementNo
                ];
              },
            },
            visible: true,
          },
          {
            field: 'gmtCreate',
            title: '创建时间',
            visible: true,
          },
          {
            field: 'statusMap',
            title: '状态',
            visible: true,
          },
        ];
      },
    },
    mounted() {
      this.businessGroup = this.userInfo.businessGroup;
    },
    methods: {
      changePageHandler(pageNum, pageSize) {
        this.page.pageNum = pageNum;
        this.page.pageSize = pageSize;
        console.log('修改页面', pageNum, pageSize);
        this.getTableData();
      },
      async getTableData(orderName) {
        console.log('请求进行中数据', orderName);
        this.tableData = [];
        this.keyTime = new Date().getTime();
        this.getDataByOrderType('02');
      },
      // 清空表格数据
      // clearTableData(){
      //   this.tableData=[];
      // }
    },
    watch: {
      orderName: {
        handler(val) {
          console.log('表格数据变化===', val);
          this.keyTime = new Date().getTime();
          if (this.activeTab == '02') {
            // this.getTableData(val);
            this.changePageHandler(1, 10);
          }
        },
        immediate: true,
        deep: true,
      },
      indexType: {
        handler(val) {
          console.log('监听获取值indexType', val);
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>

<style></style>
